// CustomModals.tsx
import React from "react";
import { ConfirmationInitializationMessage } from "@components/Common/ConfirmationInitializationMessage";
import { ConfirmationUpdatingDataMessageModal } from "@components/Common/ConfirmationUpdatingDataMessageModal";
import { ConfirmationActiveModeOfSale } from "../ConfirmationActiveModeOfSale";
import HistoryModal from "../HistoryModal";
import { ConfirmationFavorite } from "./ConfirmationFavorite";
import ModalLoading from "@components/Common/ModalLoading";
import { t } from "i18next";
import { INITIAL_SALE_MODE_FORM_STATE } from "./modeOfSaleCheckers";

type customColumnProps = {
    setIsEdited: Function;
    isActionsClicked: boolean;
    actions: any;
    validationAction: any;
    setIsActionsClicked: Function;
    selectedRows: any;
    setDataIsUpdated: Function;
    rowData: any;
    isLoading: any;
    setModalState: Function;
    modalState: any;
    setFormState: Function;
};
export const CustomModals = ({
    setIsEdited,
    isActionsClicked,
    actions,
    validationAction,
    setIsActionsClicked,
    selectedRows,
    setDataIsUpdated,
    rowData,
    isLoading,
    setModalState,
    modalState,
    setFormState,
}: customColumnProps) => {
    function setIsInInitializationModalOpened(value: boolean) {
        setModalState({ ...modalState, isInInitializationModalOpened: value });
    }
    function setIsAddNewModeOfSaleButtonClicked(value: boolean) {
        setModalState({
            ...modalState,
            isAddNewModeOfSaleButtonClicked: value,
            isInInitializationModalOpened: false,
        });
        setFormState({ ...INITIAL_SALE_MODE_FORM_STATE });
    }

    return (
        <React.Fragment>
            {modalState.isModalOpened && (
                <ConfirmationActiveModeOfSale
                    setModalState={setModalState}
                    modalState={modalState}
                    setDataIsUpdated={setDataIsUpdated}
                    selectedRows={selectedRows}
                    isOneShop={true}
                />
            )}
            {modalState.isInInitializationModalOpened && (
                <ConfirmationInitializationMessage
                    isModalOpened={modalState.isInInitializationModalOpened}
                    setIsModalOpened={setIsInInitializationModalOpened}
                    setIsClicked={setIsAddNewModeOfSaleButtonClicked}
                    isClicked={modalState.isAddNewModeOfSaleButtonClicked}
                    setIsEdited={setIsEdited}
                />
            )}
            {modalState.isHistoryModalOpened && (
                <HistoryModal
                    ids={selectedRows}
                    setModalState={setModalState}
                    modalState={modalState}
                    rowData={rowData}
                    setData={setDataIsUpdated}
                />
            )}
            {modalState.isFavoriteModified && (
                <ConfirmationFavorite
                    setModalState={setModalState}
                    modalState={modalState}
                    e={rowData}
                    setDataIsUpdated={setDataIsUpdated}
                />
            )}
            {isActionsClicked && (
                <ConfirmationUpdatingDataMessageModal
                    isModalOpened={isActionsClicked}
                    setIsModalOpened={setIsActionsClicked}
                    validationAction={validationAction}
                    actions={actions}
                    setIsEdited={setIsEdited}
                />
            )}
            {isLoading && (
                <ModalLoading
                    isOpen={isLoading}
                    data={{
                        title: t("Alert"),
                        message: t("The action is currently being processed."),
                    }}
                />
            )}
        </React.Fragment>
    );
};
